import { z } from 'zod'

export const commonGetSysMessageSchema = z.object({
  /** 標題 */
  subject: z.string(),
  /** 內容 */
  content: z.string()
})

export interface CommonGetSysMessage
  extends z.infer<typeof commonGetSysMessageSchema> {}
